<template>
  <tr @click="toggleExpanded" :class="{ disabled: item.disabled, pickable: item.signaturePick }">
    <td class="">
      <v-icon v-if="isFinal" :color="color">done_all</v-icon>
      <span class="position" v-else-if="item.position < 6">{{
        item.position
      }}</span>
      <v-icon v-else :color="color">{{ appreciation }}</v-icon>
    </td>
    <td v-if="$mq === 'lg'">{{ item.proposed | shortDate }}</td>
    <td>{{ host != null ? host.address : "-" }}</td>
    <td v-if="$mq === 'lg'">
      {{ host != null ? Math.round(host.carrez) + " m²" : "-" }}
    </td>
    <td v-if="$mq === 'lg'">{{ host != null ? host.price + " €" : "-" }}</td>
    <td v-if="$mq === 'lg'">
      {{ host != null && host.numberOfRoom !== -1 ? host.numberOfRoom : "-" }}
    </td>
    <td v-if="$mq === 'lg'">{{ host != null ? host.contactName : "-" }}</td>
    <td v-if="$mq === 'lg'">
      {{
        host != null && host.contactPhoneNumber != null
          ? host.contactPhoneNumber.replace(/\s/g, "")
          : "-"
      }}
    </td>
    <td v-if="mode === 'proposal' && $mq === 'lg'">
      <span v-if="item.distanceCar"
        >{{ (item.distanceCar / 60).toFixed(0) }} mns</span
      >
      <span
        style="border-bottom: 1px dashed red; color: red;"
        v-else-if="project.addressWork == null || project.addressWork === ''"
        title="Pas d'adresse de travail"
      >
        ⚠
      </span>
      <span v-else>
        ??
      </span>
    </td>
    <td v-if="mode === 'proposal' && $mq === 'lg'">
      <v-icon>{{ item.visited != null ? "done" : "" }}</v-icon>
    </td>
    <td v-if="mode === 'proposal'">
      {{ readableStatus }}
    </td>
    <td v-if="mode === 'visit' && item.visited != null">
      {{ item.visited ? item.visited.dateVisite : "Annulée" | fullDate }}
    </td>
    <td v-if="mode === 'visit' && item.visited == null">
      Annulée
    </td>
    <td v-if="mode === 'visit'">
      <v-icon>{{ folderStatusIcon }}</v-icon>
    </td>
    <td><v-icon color="#FF7C5D" v-if="hasNotif">whatshot</v-icon></td>
    <td>
      <v-icon :color="hasNotif ? '#FF7C5D' : '#60A694'">{{
        value ? "arrow_drop_down" : "arrow_right"
      }}</v-icon>
    </td>
  </tr>
</template>
<script>
import { PROJECT_STATUS } from "../../data/DefaultSettings";
import moment from "moment";
import { likedOrDisliked } from "../../utils";
import { addDistancesToProposal } from "../../services/maps";
import { mapActions, mapState } from "vuex";

export var IS_REFRESHING_DIRECTIONS = false;

export default {
  props: ["item", "mode", "value"],

  timers: {
    checkAddress: { time: 2000, autostart: true, repeat: true }
  },

  data() {
    return {
      lastAddressCheck: null,
      addressDebounceCheck: ""
    };
  },

  mounted() {
    if (this.item.idSell === this.$route.params.sub_id) {
      this.$emit("input", true);
    }
  },
  methods: {
    ...mapActions("projects", ["fetchProposals"]),
    toggleExpanded() {
      const expanded = !this.value;
      if (expanded) {
        this.$router.replace(
          `/project/${this.item.idBuy}/${this.mode}s/${this.item.idSell}`
        );
      }
      this.$emit("input", expanded);
    },
    async refreshDirections() {
      IS_REFRESHING_DIRECTIONS = true;
      this.lastAddressCheck = this.host.address;
      await addDistancesToProposal(this.project, this.host);
      await this.fetchProposals({
        id: this.project._id
      });
      IS_REFRESHING_DIRECTIONS = false;
    },

    async checkAddress() {
      if (
        this.host.address !== this.item.lastGeocodingAddress &&
        this.host.address !== this.lastAddressCheck &&
        !IS_REFRESHING_DIRECTIONS &&
        this.project.addressWork
      ) {
        if (this.addressDebounceCheck !== this.host.address) {
          this.addressDebounceCheck = this.host.address;
          return;
        }

        this.refreshDirections();
      }
    }
  },
  computed: {
    ...mapState("projects", {
      project: state => state.current
    }),
    ...mapState("notifications", {
      notifications: state => state.all
    }),
    host() {
      return this.item._host;
    },
    isFinal() {
      return this.project.chosenEstate === this.item.idSell;
    },
    appreciation() {
      switch (likedOrDisliked(this.item)) {
        case 1:
          return "sentiment_satisfied";
        case 2:
          return "sentiment_dissatisfied";
        case 3:
          return "query_builder";
      }
    },
    color() {
      if (
        this.item.liked != null &&
        (this.item.disliked == null ||
          moment(this.item.liked) > moment(this.item.disliked))
      ) {
        return "green";
      } else if (
        this.item.disliked != null &&
        (this.item.liked == null ||
          moment(this.item.disliked) > moment(this.item.liked))
      ) {
        return "red";
      } else {
        return "black";
      }
    },
    folderStatusIcon() {
      switch (this.item.folderStatus) {
        case "submitted":
          return "query_builder";
        case "accepted":
          return "check";
        case "rejected":
          return "clear";
        default:
          return "";
      }
    },
    hasNotif() {
      return (
        this.notifications.filter(
          ({ idProject, idEstate, seen }) =>
            this.item.idBuy === idProject &&
            this.item.idSell === idEstate &&
            !seen
        ).length > 0
      );
    },
    readableStatus() {
      const [readable] = PROJECT_STATUS.filter(
        ({ value }) => value === this.item.status
      );
      return readable ? readable.text : "";
    }
  }
};
</script>

<style scoped>
.position {
  width: 24px;
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #60a694;
}

.disabled {
  opacity: 0.3;
}

.pickable {
  background-color: rgba(96, 166, 148, 0.1);
}
</style>
